<template>
  <v-ons-page modifier="secondary">
    <div class="background" />
    <div :class="['content', layoutClass]">
      <map-component v-for="visualizationLayerType in visualizationLayerTypes"
        :key="visualizationLayerType"
        :visualizationLayerType="visualizationLayerType"
        :class="'layer-' + visualizationLayerType"
       />
    </div>

    <!-- NOTE: Spot, Thingの自動更新をする -->
    <automatic-area-updater :visualizationLayerTypes="visualizationLayerTypes" />
  </v-ons-page>
</template>

<script>
import config from '@/config.js';
import mapComponent from './map.vue';
import automaticAreaUpdater from './partials/automatic_area_updater.vue';


export default {
  components: {
    mapComponent,
    automaticAreaUpdater,
  },
  computed: {
    visualizationLayerGroups: () => config.visualizationLayerGroups,
    targetGroup(vm) {
      const groups = config.visualizationLayerGroups;
      return (
        groups.find(g => g.value === vm.urlTargetParam) ??
        groups[0]
      );
    },
    visualizationLayerTypes(vm) {
      return vm.targetGroup.visualizationLayerTypes;
    },
    urlTargetParam() {
      return new URLSearchParams(window.location.search).get('target');
    },
    layoutClass(vm) {
      return vm.targetGroup.layoutClass ?? '';
    }
  },
};
</script>

<style scoped lang="scss">
.background {
  background: #dbdcdc;
}
.content {
  overflow: hidden;
  height: 100vh;
  width: 100vw;
  box-sizing: border-box;
  padding: 20px 0 20px;
  display: grid;
  row-gap: 20px;
  grid-template-rows: repeat(auto-fit, minmax(0, 1fr));

  &.group4-layout {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
    row-gap: 20px;
    grid-template-areas:
      "wind_speed eco2"
      ". sound";

    /deep/ .layer-wind_speed {
      grid-area: wind_speed;
      overflow: hidden;
    }
    /deep/ .layer-eco2 {
      grid-area: eco2;
      overflow: hidden;
    }
    /deep/ .layer-sound {
      grid-area: sound;
      overflow: hidden;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?41a6326c